(function() {
  var STORAGE_KEY = 'oleo_search_state';
  var _initialized = false;

  function saveState(marca, modelo, categoria, subcategoria) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ marca: marca, modelo: modelo, categoria: categoria, subcategoria: subcategoria }));
  }

  function loadState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch(e) { return {}; }
  }

  function populateModelos(marca, selectedModelo) {
    var selectModelo = document.querySelector('#select-modelo');
    if (!selectModelo) return;
    if (!marca || !window.oleoModelos || !window.oleoModelos[marca]) {
      selectModelo.innerHTML = '<option value="">Selecione primeiro a Marca</option>';
      selectModelo.disabled = true;
      return;
    }
    selectModelo.innerHTML = '<option value="">Selecione o Modelo</option>';
    window.oleoModelos[marca].forEach(function(m) {
      var opt = document.createElement('option');
      opt.value = m.v;
      opt.textContent = m.t;
      if (selectedModelo && m.v === selectedModelo) opt.selected = true;
      selectModelo.appendChild(opt);
    });
    selectModelo.disabled = false;
  }

  function populateSubcategorias(categoriaVal, selectedSubcat) {
    var selectSubcategoria = document.querySelector('#select-subcategoria');
    if (!selectSubcategoria) return;
    selectSubcategoria.innerHTML = '<option value="">Todas as Subcategorias</option>';
    if (!categoriaVal || !window.oleoSubcategorias || !window.oleoSubcategorias[categoriaVal]) return;
    window.oleoSubcategorias[categoriaVal].forEach(function(s) {
      var opt = document.createElement('option');
      opt.value = s.v;
      opt.textContent = s.t;
      if (selectedSubcat && s.v === selectedSubcat) opt.selected = true;
      selectSubcategoria.appendChild(opt);
    });
  }

  function restoreState() {
    var state = loadState();
    if (!state.marca) return;
    var selectMarca = document.querySelector('#select-marca');
    var selectCategoria = document.querySelector('#select-categoria');
    if (selectMarca && state.marca) {
      selectMarca.value = state.marca;
      populateModelos(state.marca, state.modelo);
    }
    if (selectCategoria && state.categoria) {
      selectCategoria.value = state.categoria;
      populateSubcategorias(state.categoria, state.subcategoria);
    }
  }

  function cleanTag(val) {
    // Remove prefixo tag: se existir, devolve só o valor limpo
    return val.replace(/^tag:/, '');
  }

  function init() {
    if (_initialized) return;
    _initialized = true;


    document.addEventListener('change', function(e) {
      if (e.target && e.target.id === 'select-marca') populateModelos(e.target.value, null);
      if (e.target && e.target.id === 'select-categoria') populateSubcategorias(e.target.value, null);
    });

    document.addEventListener('click', function(e) {
      if (e.target && e.target.classList.contains('btn-pesquisar')) {
        e.preventDefault();

        var modelo = document.querySelector('#select-modelo') ? document.querySelector('#select-modelo').value : '';
        var categoria = document.querySelector('#select-categoria') ? document.querySelector('#select-categoria').value : '';
        var subcategoria = document.querySelector('#select-subcategoria') ? document.querySelector('#select-subcategoria').value : '';
        var marca = document.querySelector('#select-marca') ? document.querySelector('#select-marca').value : '';

        saveState(marca, modelo, categoria, subcategoria);

        var queryParts = [];
        if (modelo) queryParts.push('tag:' + cleanTag(modelo));
        if (subcategoria) {
          queryParts.push('tag:' + cleanTag(subcategoria));
        } else if (categoria) {
          queryParts.push('tag:' + cleanTag(categoria));
        }

        var url = queryParts.length > 0
          ? '/search?type=product&q=' + encodeURIComponent(queryParts.join(' '))
          : '/collections/all';

        window.location.href = url;
      }
    });

    restoreState();
  }

  function waitForForm() {
    if (document.querySelector('#select-marca') && document.querySelector('#select-modelo')) {
      init();
    } else {
      setTimeout(waitForForm, 300);
    }
  }

  setTimeout(waitForForm, 0);
  setTimeout(waitForForm, 500);
  setTimeout(waitForForm, 1000);
  setTimeout(waitForForm, 2000);

})();














